// extracted by mini-css-extract-plugin
export default {"preview":"nhN4j_qXiN4aWx6yJwAb"};